import {Component, Input, OnInit, EventEmitter} from '@angular/core';
import {GlobalService} from "../../../shared/services/global.service";
import {FileUploader} from 'ng2-file-upload';
import {Constantes} from "../../../shared/constantes";
import {ProductsService} from "../../../shared/services/products.service";
import {NotificationService} from "../../../shared/services/notification.service";
import {Router} from "@angular/router";
/******************* Drag and Drop sorting ***************************************/
import { CdkDragDrop, moveItemInArray, transferArrayItem } from "@angular/cdk/drag-drop";
/******************* Drag and Drop sorting ***************************************/
@Component({
  selector: 'app-photos',
  templateUrl: './photos.component.html',
  styleUrls: ['./photos.component.css']
})
export class PhotosComponent implements OnInit {
  ItemsUpdatedRankList: any = [];
  ExistedPhotos: any = [];
  NewAddPhotos: any = [];
  uploadMessageList: any = [];
  maxFileSizeHtml=Constantes.maxFileSizeHtml;
  imgSrc:string='';
  modalPhotoShow:boolean=true;
  loadExistedPhotos:boolean=true;
  public previewPath: any;
  currentUrl:string='';
  @Input() productId: number|undefined;
  @Input() Product: any = [];
  uploader: FileUploader = new FileUploader(Constantes.FileUploaderConfig);
  channels: any = [];
  defaultChannel=Constantes.defaultChannel;
  constructor(
    private router:Router,
    private productService:ProductsService,
    private globalService: GlobalService,
    private notification: NotificationService
  )
  {
    /************************** if upload error *******************************/
    this.uploader.onWhenAddingFileFailed = (item, filter) => {
      console.log('enter upload failed error');
      let message = '';
      switch (filter.name) {
        case 'fileSize':
          message = 'L\'image téléchargée  "' + item.name + '\" fait ' + this.globalService.formatBytes(item.size,null) + ', cela dépasse la taille maximale autorisée de ' + this.globalService.formatBytes(Constantes.maxFileSize,null);
          this.uploadMessageList.push({'message':message});
          $('.alerteUploadPhoto').show();
          break;
          default:
          message = 'Une erreur s’est produite lors de la tentative d\'uploader la photo :  '+item.name;
          this.uploadMessageList.push({'message':message});
          break;
      }
    };
    /************************** if upload error *******************************/
  }
  /******************* Drag and Drop sorting ***************************************/

  GetNewItemListAfterSortWithDragDrop (event: CdkDragDrop<string[]>)
  {
    console.log('event == ', event);
    if (event.previousContainer === event.container)
    {
      moveItemInArray(this.ExistedPhotos, event.previousIndex, event.currentIndex);
      this.setItemsUpdatedRankList(this.ExistedPhotos);
    }
    else
    {
      transferArrayItem(event.previousContainer.data,this.ExistedPhotos,event.previousIndex,event.currentIndex);
      console.log(' transferArrayItem  productDescriptions ==> ', this.ExistedPhotos);
    }
  }
  /******************* Drag and Drop sorting ***************************************/
  ngOnInit(): void {
    this.getExistedPhotos();
    this.currentUrl = this.router.url;
    this.getChannels();
  }
  getChannels() {
    this.globalService.getParameterValue('', 'business_channel')
      .subscribe(
        channels => { console.log('channels',channels);
          for (let item in channels[0]['data']) {
            this.channels.push(channels[0]['data'][item]);
          }
        },
        error => {
          this.globalService.checkApiError(error);
        }
      );
  }
  onFileSelected(event: any|EventEmitter<File[]>)
  {
    this.NewAddPhotos=this.globalService.onFileSelected(event);
  }
  alerteUploadPhotoClose ()
  {
    $('.alerteUploadPhoto').hide();
  }
  remove(index:number|null)
  {
    this.NewAddPhotos.splice(index,1);
  }
  addNewPhoto()
  {

    this.globalService.showSpinner();
    let rank=null;
    let keywords=null;
    let gallery=false;
    let panoramic=false;
    let channelID=$("#channelsPhotos option:selected").val();
    let NewAddPhotosLength= this.NewAddPhotos.length;
    let NewAddPhotosRealLength= this.NewAddPhotos.length;
    if (NewAddPhotosRealLength>0)
    {
      NewAddPhotosRealLength=NewAddPhotosRealLength-1;
    }
    for (let item = 0; item <= NewAddPhotosRealLength; item++)
    {
      //rank
      rank=$('#rank_'+item).val();
      this.NewAddPhotos[item]['rank']=rank;

      //keywords
      keywords=$('#keywords_'+item).val();
      console.log('photo add component :::: keywords ********************* ',keywords);
      this.NewAddPhotos[item]['keywords']=keywords;

      //gallery
      if ($('#gallery_'+item).prop('checked'))
      {
        gallery=true;
      }
      else
      {
        gallery=false;
      }
      this.NewAddPhotos[item]['gallery']=gallery;

      //panoramic
      if ($('#panoramic_'+item).prop('checked'))
      {
        panoramic=true;
      }
      else
      {
        panoramic=false;
      }
      this.NewAddPhotos[item]['panoramic']=panoramic;

      /***********************************************  CALL API ADD PHOTO  ******************************************************************/

      let name=this.NewAddPhotos[item]['name'];
      this.productService.addEditProductMedia(this.NewAddPhotos[item]['Base64'],this.NewAddPhotos[item]['name'],this.NewAddPhotos[item]['width'],this.NewAddPhotos[item]['height'],this.NewAddPhotos[item]['size'],this.NewAddPhotos[item]['rank'],this.productId,this.NewAddPhotos[item]['panoramic'],this.NewAddPhotos[item]['gallery'],null,null,channelID,this.NewAddPhotos[item]['keywords']).subscribe(
        response =>
        {console.log('response add photo',response);
          if (response.status=200)
          {

            this.notification.showSuccess("La photo' "+ name +" ' a été ajoutée avec succès","");
            let index=this.NewAddPhotos.indexOf(item);
            this.remove(index);
            this.ExistedPhotos=[];
            this.ExistedPhotos.length=0;
            this.globalService.hideSpinner();
            let This = this;
            /************************* refrech component data ********************************/
            if((item+1) == NewAddPhotosLength)
            {
              setTimeout(function () {
                let documentHeight: any = $(document).height();
                let windowHeight: any = $(window).height();
                let bottomPosition = (documentHeight * 1) - (windowHeight * 1);
                if ($(document).height() && $(window).height()) {
                  This.getExistedPhotos();
                  $("html, body").animate({scrollTop: bottomPosition}, "slow");
                }
              }, 1500);
            }
            /************************* refrech component data ********************************/
          }
        },
        error => {

          this.globalService.checkApiError(error);
          this.globalService.hideSpinner();
          this.notification.showError(error['error']['hydra:description'],"");
        }
      );
    }
    $('#photosUploaded').val('');
    this.NewAddPhotos=[];
    this.NewAddPhotos.length=0;
    this.uploader.queue.length=0;
    this.uploader.clearQueue();
    this.uploader.destroy();
    /***********************************************  CALL API ADD PHOTO  ******************************************************************/
  }
  updatePhoto(photoId:number,name:string)
  {
    this.globalService.showSpinner();
    let rank:any;
    let keywords:any|null='';
    let panoramic:boolean=false;
    let gallery:boolean=false;
    let isList:boolean=false;
    let channelID=$("#channelsPhotos option:selected").val();
    if ($('#panoramic_'+photoId).prop('checked'))
    {
      panoramic=true;
    }

    if ($('#gallery_'+photoId).prop('checked'))
    {
      gallery=true;
    }

    if ($('#isList_'+photoId).prop('checked'))
    {
      isList=true;
    }
    rank=$('#rank_'+photoId).val();

    //keywords
    keywords=$('#keywords_'+photoId).val();


    this.productService.addEditProductMedia(null,null,null,null,null,rank,this.productId,panoramic,gallery,isList,photoId,channelID,keywords).subscribe(
      response =>
      {
        if (response.status=200)
        {
          this.globalService.hideSpinner();
          this.notification.showSuccess("La photo ' "+ name +" ' a été modifiée avec succès","");
          $("html, body").animate({ scrollTop: 0 }, "slow");
        }
      },
      error => {

        this.globalService.checkApiError(error);
        this.globalService.hideSpinner();
        this.notification.showError(error['error']['hydra:description'],"");
      }
    );
  }
  DeletePhoto(item:any)
  {
    let globalService=this.globalService;
    let productService=this.productService;
    let ExistedPhotos=this.ExistedPhotos;
    let notification=this.notification;
    this.notification.ConfirmAction("Êtes-vous sûr de vouloir supprimer",item.name,"Valider","Supprimer !","", function (confirmed:any)
    {
      if (confirmed)
      {
        globalService.showSpinner();
        productService.deleteProductMedia(item.id).subscribe(
          deletedResponse => {
            globalService.hideSpinner();
            let index = ExistedPhotos.indexOf(item);
            if (index > -1)
            {
              ExistedPhotos.splice(index, 1);
              globalService.hideSpinner();
              notification.showSuccess("La photo ' "+item.name+" ' a été supprimée avec succès","");
              $("html, body").animate({ scrollTop: 0 }, "slow");
            }
          },
          error => {
            globalService.hideSpinner();
            globalService.checkApiError(error);
            globalService.hideSpinner();
            notification.showError(error['error']['hydra:description'],"");
          }
        );
      }
      else
      {
        console.log('response ==> false');
      }
    });
  }
  zoom(event:any)
  {
    let target = event.target || event.srcElement || event.currentTarget;
    let srcAttr = target.attributes.src;
    this.imgSrc = srcAttr.nodeValue;
    this.modalPhotoShow=false;
  }
  closeModalPhoto()
  {
    this.modalPhotoShow=true;
  }
  getExistedPhotos()
  {
    this.globalService.showSpinner();
    let channelCode=$("#channelsPhotos option:selected").attr("code");
    if (!channelCode)
    {
      channelCode=Constantes.defaultChannelCode;
    }
    this.ExistedPhotos=[];
    this.productService.getProductMedia(this.productId,channelCode)
      .subscribe(
        ExistedPhotos => {
          for (let item in ExistedPhotos[0]['data']) {
            this.ExistedPhotos.push(ExistedPhotos[0]['data'][item]);
          }
          this.globalService.hideSpinner();
        },
        error => {
          this.globalService.checkApiError(error);
          this.globalService.hideSpinner();
        }
      );
    this.loadExistedPhotos=false;
  }
  setItemsUpdatedRankList(items:[])
  {
    this.ItemsUpdatedRankList=[];
    items.forEach((value, index) =>
    {
      let rank=index+1;
      this.ItemsUpdatedRankList.push({"id":value['id'],"rank":rank});
    });
    this.productService.updateProductMediasDetailRank('ProductMedia','product_medias',this.ItemsUpdatedRankList)
      .subscribe(
        response => { console.log('response rank update ',response);
        },
        error => {
          this.globalService.checkApiError(error);
        }
      );
  }
}
